import { If, Progress, SpinnerOverlay, Variant } from '@fold-dev/core'

export const LoadingLine = ({ loading, variant = 'accent', style = {} }) => {
    return (
        <If if={loading}>
            <div
                style={{
                    top: 0,
                    left: 0,
                    position: 'absolute',
                    width: '100%',
                    height: 'fit-content',
                    background: 'transparent',
                    zIndex: 100,
                    ...style,
                }}>
                <Progress
                    value={50}
                    thickness={3}
                    variant={variant as Variant}
                    indeterminate
                    bgToken="transparent"
                />
            </div>
        </If>
    )
}

export const Loading = ({ loading }) => {
    return (
        <If if={loading}>
            <SpinnerOverlay bg="rgb(from var(--f-color-surface) r g b / 25%)" />
        </If>
    )
}
